import { InitWannabeeAdminCustomers } from "./admincustomers/AdminCustomers";
import { InitWannabeeDebts } from "./admincustomers/Debts";
import { InitWannabeeCustomers } from "./customers/Customers";
import { InitWannabeeNewsletters } from "./newsletter/Newsletter";
import { InitWannabeeOldbarcodefix } from "./oldbarcodefix/Oldbarcodefix";
import { InitWannabeeOrdering } from "./ordering/Ordering";
import { InitWannabeeProducts } from "./products/Products";
import { InitWannabeeProductsStorageFix } from "./products_storage_fix/ProductsStorageFix";
import { InitWannabeeRelevantProducts } from "./relevantproducts/RelevantProducts";
import { InitWannabeeStatus } from "./status/Status";
import { InitWannabeeStatusfix } from "./statusfix/statusfix";
import { InitWannabeeStockfix } from "./stockfix/Stockfix";
import { InitWholesalePrice } from "./wholesaleprice/WholesalePrice";

class Main{
    constructor(){
        new InitWannabeeCustomers();
        new InitWannabeeNewsletters();
        new InitWannabeeProducts();
        new InitWannabeeRelevantProducts();
        new InitWholesalePrice();
        new InitWannabeeAdminCustomers();
        new InitWannabeeDebts();
        new InitWannabeeOrdering();
        new InitWannabeeStatus();
        new InitWannabeeStockfix();
        new InitWannabeeOldbarcodefix();
        new InitWannabeeStatusfix();
        new InitWannabeeProductsStorageFix();
    }
}
new Main();